@if (data(); as msg) {
    Updated <room-item [room]="msg.room" />
}
 